import getApi from '../../../api'
import { EphemeralNotification } from '../../../model/EphemeralNotification'

export const postEphemeralNotification = (ephemeralNotification: EphemeralNotification) => {
  return getApi().post<EphemeralNotification>(
    `/admin/ephemeral_notifications`,
    ephemeralNotification,
  )
}
